import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom';
import ReactGA from 'react-ga';
import Routing, {ScrollToTop} from '@/Routing';
import {createMuiTheme, MuiThemeProvider} from '@material-ui/core/styles';
import * as serviceWorker from './serviceWorker';
// import getFont from 'get-font';

import 'normalize.css';
import './index.css';

const theme = createMuiTheme({
    breakpoints: {
        values: {
            xs: 320,
            sm: 769,
            md: 1024,
            lg: 1280,
            xl: 1920,
        }
    },
    typography: {
        fontFamily: 'Helvetica, Arial, sans-serif',
    }
});

// const font = getFont({
//     name: 'MailSans',
//     baseUrl: '//img.imgsmail.ru/hb/e.mail.ru/static/fonts',
//     hasVariative: true,
//     hasItalic: true,
//     weights: {
//         400: 'Regular',
//         500: 'Medium',
//         600: 'DemiBold',
//     },
//     prefetchedWeights: [400, 500, 600],
// });

ReactGA.initialize('UA-61473114-2');
// document.getElementsByTagName('head')[0].innerHTML += font;

ReactDOM.render(
    <BrowserRouter>
        <ScrollToTop>
            <MuiThemeProvider theme={theme}>
                <Routing />
            </MuiThemeProvider>
        </ScrollToTop>
    </BrowserRouter>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
